<template>
  <div class="container-fluid py-4">

    <div class="row mb-4">
      <div class="col-12">
        <div class="card-header p-3 d-flex justify-content-between align-items-center header-bar">
          <h6 class="text-white m-0">
            {{ $t("editprofil.header.title") }}
          </h6>

          <router-link to="/employee/profile">
            <button class="btn btn-sm export-btn">
              <i class="fas fa-arrow-left me-1"></i>
              {{ $t("editprofil.header.back") }}
            </button>
          </router-link>
        </div>
      </div>
    </div>

    <div class="card p-4">
      <h5 class="mb-3">
        {{ $t("editprofil.section.personalInfo") }}
      </h5>

      <div class="row">
        <div class="col-md-6 mb-3">
          <label>{{ $t("editprofil.fields.firstname") }}</label>
          <input class="form-control" v-model="form.firstname" />
        </div>

        <div class="col-md-6 mb-3">
          <label>{{ $t("editprofil.fields.lastname") }}</label>
          <input class="form-control" v-model="form.lastname" />
        </div>

        <div class="col-md-6 mb-3">
          <label>{{ $t("editprofil.fields.phone") }}</label>
          <input class="form-control" v-model="form.phone_number" />
        </div>

        <div class="col-md-6 mb-3">
          <label>{{ $t("editprofil.fields.dateOfBirth") }}</label>
          <input type="date" class="form-control" v-model="form.date_of_birth" />
        </div>

        <div class="col-md-6 mb-3">
          <label>{{ $t("editprofil.fields.gender") }}</label>
          <select class="form-control" v-model="form.gender">
            <option value="">{{ $t("editprofil.gender.select") }}</option>
            <option value="Male">{{ $t("editprofil.gender.male") }}</option>
            <option value="Female">{{ $t("editprofil.gender.female") }}</option>
          </select>
        </div>

        <div class="col-md-6 mb-3">
          <label>{{ $t("editprofil.fields.maritalStatus") }}</label>
          <select class="form-control" v-model="form.marital_status">
            <option value="">{{ $t("editprofil.maritalStatus.select") }}</option>
            <option>Single</option>
            <option>Married</option>
            <option>Divorced</option>
            <option>Widowed</option>
          </select>
        </div>
      </div>

      <button class="btn save-btn mt-3" @click="save">
        {{ $t("editprofil.actions.save") }}
      </button>
    </div>

  </div>
</template>

<script>
import axios from "@/api";
import { useToast } from "vue-toastification";

export default {
  name: "EditEmployee",

  data() {
    return {
      toast: useToast(),
      userId: this.$route.query.user_id,
      form: {}
    };
  },

  mounted() {
    this.load();
  },

  methods: {
    async load() {
      const user = await axios.get(`/getUser/${this.userId}`);
      const info = await axios.get(`/employee/personal-information/${this.userId}`);
      this.form = { ...user.data.user, ...info.data.data };
    },

    async save() {
      try {
        await axios.post(`/employee/update-personal-info/${this.userId}`, this.form);
        this.toast.success(this.$t("editprofil.toast.success"));
        this.$router.push("/employee/profile");
      } catch {
        this.toast.error(this.$t("editprofil.toast.error"));
      }
    }
  }
};
</script>


<style scoped>
.header-bar {
  background: linear-gradient(195deg, #4b5563, #8d2e38);
  border-radius: 12px;
}

.export-btn {
  background-color: white;
  color: #b03a45;
  border: 1px solid #b03a45;
}

.export-btn:hover {
  background-color: #b03a45;
  color: white;
}

/* NEW SAVE BUTTON STYLE */
.save-btn {
  background-color: #b03a45 !important;
  color: white !important;
  padding: 10px 22px;
  font-weight: 600;
  border-radius: 8px;
  border: none;
}

.save-btn:hover {
  background-color: #8d2e38 !important;
}
</style>
